import { PlayCircle } from "@mui/icons-material";
import { height } from "@mui/system";
import { Link, useLocation, useHistory } from "react-router-dom";
import React from "react";
import { VideoJS } from "../../../components";
import ModalLayout from "../../../components/Modal/Modal";
import "./slide.css"

function Slide(props) {
  const { slide } = props;
  const playerRef = React.useRef(null);
  const [modal, setModal] = React.useState(false);

  return (
    <section className="slide" style={{ backgroundImage: 'url(./img/bg.jpg)' }}>
      <div className="awe-overlay overlay-color-3" />
      <div className="container">
        <div className="">
          {/* SLIDE ITEM */}
          <div className="flex-column justify-center align-center height-card">
            <div className="flex align-center justify-center m-8 md:m-0 md:items-center h-full">
              <div className="d-flex flex-column align-center justify-center w-2/3 md:w-1/2 wrap-card">
                <div className="d-flex flex-column justify-center">
                  <h2 className="slide-header">{slide?.title}</h2>
                  <p className="slider-description">{slide?.description}</p>
                  <div className="group">
                    <Link to="/courses" className="mc-btn btn-style-1">See Our Courses</Link>
                  </div>
                </div>
              </div>
              <div className=" w-1/2">
                <div className="image-position">
                  <img src={process.env.REACT_APP_LOCAL_FILE_PATH + "page/large/" + slide?.image} alt="" />
                </div>
              </div>
            </div>
          </div>
          {/* SLIDE ITEM */}

        </div>
      </div>
    </section>
  );
}

export default Slide;
